import api from './api'

class UserService {
    // 获取用户信息
    static async getUserInfo() {
        const response = await api.get('/user/info/')
        return response.data
    }

    // 更新用户信息
    static async updateUserInfo(userData) {
        const response = await api.post('/userupdate/update_user_info/', userData);
        return response.data;
    }

    // 更新用户信息（包含文件上传）
    static async updateUserInfoWithAvatar(userData) {
        // 设置Content-Type为multipart/form-data，让浏览器自动设置boundary
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        const response = await api.post('/userupdate/update_user_info/', userData, config);
        return response.data;
    }

    // 获取所有应用
    static async getAllApps(userType) {
        console.log("getAllApps userType:", userType)
        // 修改这里，使用带baseURL的api实例而不是apiWithoutBaseURL
        const response = await api.post('/getallapps/', { usertype: userType })
        return response.data
    }

    // 获取用户已订阅的应用
    static async getUserApps(userId) {
        const response = await api.get(`/user/${userId}/apps/`)
        console.log("getUserApps response:", response.data)
        return response.data
    }

    // 为用户添加应用
    static async addAppForUser(userId, appId) {
        const response = await api.post('/addappforuser/', {
            userid: userId,
            appid: appId
        })
        return response.data
    }

    // 添加链接
    static async addLink(linkData) {
        const response = await api.post('/addLink/', linkData)
        return response.data
    }

    // 删除图谱节点
    static async deleteGraph(graphId) {
        const response = await api.post('/deleteGraph/', { graphId })
        return response.data
    }

    // 检查节点是否存在
    static async checkNode(nodeName) {
        const response = await api.get(`/Graph/api/checkNode/?node_name=${nodeName}`)
        return response.data
    }
}

export default UserService